import { render } from "./PinnIcon.vue?vue&type=template&id=5a15602b&ts=true"
import script from "./PinnIcon.vue?vue&type=script&lang=ts"
export * from "./PinnIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__